import { useNavigate } from "react-router-dom";
import { convertDate } from "../../../../components/convert-date";
import { useState } from "react";
import { getAuth, signOut } from "firebase/auth";
import IconMemberPro from '../../../../components/images/member-pro.svg';
import './style.css';

export default function Main( { profile, signature, copied } ) {

    const navigate = useNavigate();
    
    const handleLogout = async () => {
        const auth = getAuth();

        signOut(auth).then(() => {
            alert('Você foi desconectado com sucesso.');
            navigate('/');
        }).catch((error) => {
            console.error('Erro ao fazer logout:', error);
            alert('Erro ao fazer logout. Tente novamente.');
        });
    };

    function anonymizeEmail(email) {
        if (!email || typeof email !== "string") {
            throw new Error("E-mail inválido");
        }
        const parts = email.split("@");
        if (parts.length !== 2) {
            throw new Error("Formato de e-mail inválido");
        }
        const prefix = parts[0];
        const domain = parts[1];
        const visiblePart = prefix.slice(0, 2); // Pegando os dois primeiros caracteres
        const maskedPart = "*".repeat(prefix.length - 2); // Substituindo o restante por *
        return `${visiblePart}${maskedPart}@${domain}`;
    }

    return (
        <div className="account">
            {copied &&
                <span className="span-copied">"{copied}" foi copiado!</span>
            }
            {profile?.account_uid &&
                <>
                    <header className="header">
                        <button className="user">
                            <img loading="lazy" className="img" src={profile?.profile_photo_url} alt='user'  onError={({ currentTarget }) => {currentTarget.onerror = null; currentTarget.src="https://dflix.netlify.app/imagens/img-avatar.png";}}/>
                            <h2 className="name" title={profile?.profile_name || 'User 404'}>{profile.profile_name ? profile.profile_name : "User 404"}</h2>
                        </button>
                    </header>
                    <div className="settings">
                        <button onClick={()=>navigate('/configuracoes/conta')}>
                            <header>
                                <h2>Conta</h2>
                                <i className="fa-solid fa-chevron-right"></i>
                            </header>
                            <div className="signature-about">
                                <header>
                                    <section>
                                        <span><i className="fas fa-user"></i> {profile?.profile_name}</span>
                                    </section>
                                </header>
                                <main></main>
                                <footer>
                                    <span>{anonymizeEmail(profile?.account_email)}</span>
                                </footer>
                            </div>
                        </button>
                        <button onClick={()=>navigate('/configuracoes/assinatura')}>
                            <header>
                                <h2>Assinatura</h2>
                                <i className="fa-solid fa-chevron-right"></i>
                            </header>
                            <div className="signature-about">
                                <header>
                                    <section>
                                        <span>Membro PRO</span>
                                        <button className="icone-membro-conta">
                                            <img src={IconMemberPro} alt="membro"/>
                                        </button>
                                    </section>
                                </header>
                                <main></main>
                                <footer>
                                    <span>Válido até: {convertDate(signature?.account_member_until?.seconds * 1000)}</span>
                                </footer>
                            </div>
                        </button>
                        <button onClick={()=>navigate('/configuracoes/outras/')}>
                            <header>
                                <h2>Outros</h2>
                                <i className="fa-solid fa-chevron-right"></i>
                            </header>
                            <div className="signature-about">
                                <header>
                                    <section>
                                        <span>Outras configurações</span>
                                    </section>
                                </header>
                                <main></main>
                                <footer>
                                    <span></span>
                                </footer>
                            </div>
                        </button>
                        <button onClick={handleLogout} className="logout">
                            <header>
                                <h2>Sair</h2>
                                <i className="fa-solid fa-chevron-right"></i>
                            </header>
                            <div className="signature-about">
                                <header>
                                    <section>
                                        <span>Desconectar-se desta conta</span>
                                    </section>
                                </header>
                                <main></main>
                                <footer>
                                    <span></span>
                                </footer>
                            </div>
                        </button>
                    </div>
                </>
            }
        </div>
    )
}